import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    THROWING_PREFERENCE_LIST_START: 'THROWING_PREFERENCE_LIST_START',
    THROWING_PREFERENCE_LIST_SUCCESS: 'THROWING_PREFERENCE_LIST_SUCCESS',
    THROWING_PREFERENCE_LIST_FAILED: 'THROWING_PREFERENCE_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const throwingPreferenceListStart = (data) => ({
   type: actionType.THROWING_PREFERENCE_LIST_START,
   payload: data
})

export const throwingPreferenceListSuccess = (data) => ({
    type: actionType.THROWING_PREFERENCE_LIST_SUCCESS,
    payload: data
})

export const throwingPreferenceListFailed = (data) => ({
    type: actionType.THROWING_PREFERENCE_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function throwingPreferenceListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.THROWING_PREFERENCE_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.THROWING_PREFERENCE_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.THROWING_PREFERENCE_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* throwingPreferenceListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allThrowingpreferences = response.data.data.allThrowingpreferences.Throwingpreferences ? response.data.data.allThrowingpreferences.Throwingpreferences : null
       yield put(throwingPreferenceListSuccess(allThrowingpreferences));
    } else {
      messagePopup('','Throwing Preference List failed','error')   
      yield put(throwingPreferenceListFailed('Throwing Preference List failed')) 
    }
   } catch (error) {
     messagePopup('','Throwing Preference List failed','error')   
     yield put(throwingPreferenceListFailed('Throwing Preference List failed')) 
   }
}

export function* watchThrowingPreferenceListSaga(){
    yield takeEvery(actionType.THROWING_PREFERENCE_LIST_START, throwingPreferenceListSaga)
}